import React from "react";
import styled from "styled-components";
import Icon from "nekrasovka-ui/Icons";

const IconsGroup = styled.div`
  display: flex;
  align-items: center;

  ${(props) => props.iconsGroupStyle};
  ${(props) =>
    props.isLabelNeeded &&
    "& a {display: flex; align-items: center; margin-right: 0 !important; margin-bottom: 20px; & svg {height: 40px !important; width: 40px !important;}; & span {font-size: 15px; font-weight: bold; margin-left: 25px;}}"};

  & a {
    & svg {
      height: 30px;
      width: 30px;
    }

    &:not(:last-child) {
      margin-right: 13px;
    }
  }
`;

export default ({ isLabelNeeded, iconsGroupStyle }) => {
  return (
    <IconsGroup isLabelNeeded={isLabelNeeded} iconsGroupStyle={iconsGroupStyle}>
      <a href="https://vk.com/nekrasovkalibrary">
        <Icon icon="vk" fill="#EDEEE9" />
        {isLabelNeeded && <span>Вконтакте</span>}
      </a>
      <a href="https://www.youtube.com/channel/UC86p_dXFrISbpWuC_VB9JIA">
        <Icon icon="youtube" fill="#EDEEE9" />
        {isLabelNeeded && <span>YouTube</span>}
      </a>
    </IconsGroup>
  );
};



// WEBPACK FOOTER //
// ./src/components/IconsGroup/index.js